import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';

@Injectable()
export class ApiPostProvider {

	constructor(
		private apiProvider: ApiProvider,
	) {
	}

	saveMessages(message) {
		return this.apiProvider.post("saveMessagesBeta", message)
	}

	saveTasks(tasks) {
		return this.apiProvider.post("saveMessagesBeta", tasks);
	}

	saveEvents(events) {
		return this.apiProvider.post("saveEvents", events);
	}

	saveImages(data) {

		return this.apiProvider.post("saveAttachments2",data);

	}


}



// WEBPACK FOOTER //
// ./src/providers/api-post/api-post.ts